import { FC } from 'react';
import { Flex, Icon, Link } from '@chakra-ui/react';
import { BiHomeAlt } from 'react-icons/bi';
import { Link as ReactRouterLink } from 'react-router-dom';

import { navigateToDataRoomsPage } from '../../pages/data-rooms-page/data-rooms-page';

export const PageTopBar: FC = () => {
  return (
    <Flex p="0 2rem" minH="12" bg="resre-prussian-blue">
      <Link
        gridGap="2"
        color="white"
        display="flex"
        fontWeight="600"
        alignItems="center"
        as={ReactRouterLink}
        to={navigateToDataRoomsPage()}
        _hover={{ textDecor: 'none' }}
        data-testid="treaties-link"
      >
        <Flex alignItems="center">
          <Icon as={BiHomeAlt} fontSize="2xl" mr="1" />
        </Flex>
        Treaties
      </Link>
    </Flex>
  );
};
